import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer') // Views
const DefaultContainerAdmin = () => import('@/containers/DefaultContainerAdmin') // Views
const Home = () => import("@/views/Home")
const Dashboard = () => import("@/views/Dashboard")

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const LoginEN = () => import('@/views/pages/LoginEN')
const Register = () => import('@/views/pages/Register')

const ChkStudent = () => import('@/views/data/ChkStudent')
const ChkStudentEN = () => import('@/views/data/ChkStudentEN')

const LoginAdmin = () => import('@/views/admin/LoginAdmin')
const DashboardAdmin = () => import('@/views/admin/DashboardAdmin')
/*
// Views - Setting
const Bookingyear = () => import('@/views/setting/Bookingyear')
const Bookingcalendar = () => import('@/views/setting/Bookingcalendar')
const Bookingtransfer = () => import('@/views/setting/Bookingtransfer')

// Views - Report
const Reservations = () => import('@/views/report/Reservations')
const Reserved = () => import('@/views/report/Reserved')
const Buildings = () => import('@/views/report/Buildings')
const Reservrandom = () => import('@/views/report/ReservRandom')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// Booking
const Reserves = () => import('@/views/booking/reserves')
*/
Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: '/',
    redirect: '/pages/login',
    name: 'Home',
    component: DefaultContainer,
      children: [
        /*{
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: '',
              component: Users,
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User,
            },
          ]
        }*/
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'loginen',
          name: 'Login',
          component: LoginEN
        }
      ]
    },
    {
      path: '/data',
      redirect: '/data/404',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'chkstudent/:userid/:token',
          name: 'MFU - Qualification',
          component: ChkStudent
        }
      ]
    },
    {
      path: '/data',
      redirect: '/data/404',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'chkstudentEN/:userid/:token',
          name: 'MFU - Qualification',
          component: ChkStudentEN
        }
      ]
    },
    {
      path: '/admin',
      redirect: '/admin/404',
      name: 'LoginAdmin',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'Login',
          name: 'LoginAdmin',
          component: LoginAdmin,
        }
      ]
    },
    {
      path: '/admin',
      redirect: '/admin/404',
      name: 'DashboardAdmin',
      component: DefaultContainerAdmin,
      children: [
        {
          path: 'Dashboard',
          name: 'DashboardAdmin',
          component: DashboardAdmin,
        }
      ]
    },
    
    /*{
      path: '/booking',
      redirect: '/booking/reserves',
      name: 'booking',
      component: DefaultContainer,
      children: [
        {
          path: 'reserves',
          name: 'reserves',
          component: Reserves
        }
      ]
    },*/
  ]
})
